import { render } from "./Tasks.vue?vue&type=template&id=53d8dbcf&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-53d8dbcf"

export default script